(function(){
  console.log("[DualHeadlines] init");

  function splitFirstWord(text) {
    const m = (text || "").trim().match(/^(\S+)([\s\S]*)$/);
    return m ? `<span class="font-1">${m[1]}</span>${m[2]}` : text;
  }

  function transformHeading(el) {

    if (!el || el.dataset.dualDone === "1") return;

    // gesamten sichtbaren Text holen (egal wie viele Wrapper-Spans drin sind)
    const plain = (el.textContent || "").trim();
    if (!plain.includes(" ")) return; // 1-Wort-Headline ignorieren

    // in Zeilen/Sätze splitten: Zeilenumbruch ODER nach Punkt + Leerzeichen
    const lines = plain.split(/[\r\n]+|(?<=\.)\s+/).map(s => s.trim()).filter(Boolean);
    const html = lines.map(line => splitFirstWord(line)).join("<br>");

    el.innerHTML = html;                 // ersetzen
    el.classList.add("dual-headline");   // Montserrat für den Rest
    el.dataset.dualDone = "1";
  }

  function applyAll(root){
    const sel = [
      "h1:not(.header__logo)","h2","h3","h4","h5","h6",
      ".hero__title",".slideshow__title",
      ".section__title",".page-title",".product__title",
      ".collection-hero__title",".card__heading"
    ].join(",");
    (root || document).querySelectorAll(sel).forEach(transformHeading);
  }

  function init(){ applyAll(document); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // reagiert auf Slideshow-Wechsel, Section-Reloads, Ajax etc.
  new MutationObserver(muts => {
    muts.forEach(m => m.addedNodes &&
      m.addedNodes.forEach(n => n.nodeType === 1 && applyAll(n))
    );
  }).observe(document.documentElement, {childList:true, subtree:true});

  // Shopify Editor Events
  document.addEventListener("shopify:section:load", e => applyAll(e.target));
  document.addEventListener("shopify:section:select", e => applyAll(e.target));
})();
